import React, {FC} from 'react';
import styled from 'styled-components';

import {directHoverSelector} from '../../../../../../libs/shared/helpers/src/browser/hoverHelpers';
import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {Dropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {MessageModel} from '../../../../../models/api/messageModel';

/*
 * Props.
 */

export interface MessageViewerChatSeenProps {
  message: MessageModel;
  chatUserName?: string;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  grid-area: seen;
  margin: 0 7px;
`;

const StyledActivitiesDiv = styled.div`
  padding: 10px 12px;
  text-align: center;
`;

const StyledChatSeenDiv = styled.div`
  padding: 3px 6px;
  border-radius: 100px;
  background-color: ${(p) => p.theme.palette.blue.shade20};
  color: ${(p) => p.theme.interactiveText};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.bold};

  ${directHoverSelector} {
    color: ${(p) => p.theme.interactiveTextHover};
    background-color: ${(p) => p.theme.palette.blue.shade30};
  }
`;

/*
 * Component.
 */

export const MessageViewerChatSeen: FC<MessageViewerChatSeenProps> = (props) => {
  const {message, chatUserName} = props;

  if (!message.isSeen) {
    return null;
  }

  return (
    <StyledWrapperDiv>
      <PopoverCoordinator
        renderButton={renderSeenButton}
        renderModal={(modalProps) => renderDropdown(modalProps, chatUserName)}
        shouldHoverWhenOpen
      />
    </StyledWrapperDiv>
  );
};

/*
 * Dropdown.
 */

function renderSeenButton() {
  return (
    <StyledChatSeenDiv>
      <Trans id="chat-message-seen">Seen</Trans>
    </StyledChatSeenDiv>
  );
}

function renderDropdown(props: PopoverTransferProps, chatUserName?: string) {
  const chatUserDisplayName = chatUserName ?? 'chat visitor';
  return (
    <Dropdown {...props} placement="bottom-end">
      <StyledActivitiesDiv>
        <Trans id="chat-visitor-seenby">Seen by {chatUserDisplayName}</Trans>
      </StyledActivitiesDiv>
    </Dropdown>
  );
}
